<template>
  <div>
    <div class="header-menu-dashboard-container">
      <div class="page-header-dashboard">
        <div class="row">
          <div class="col-xs-12 col-sm-6 col-md-6">
            <h1>
              <img
                v-if="isSX"
                src="/static/images/icons/smartexchange_icon_blue.svg"
                class="dashboard-icons"
                alt="smartexchange-icon"
              />
              <img
                v-else
                src="/static/images/icons/submission_icon_blue.svg"
                class="dashboard-icons"
                alt="submission-icon"
              />Projects
            </h1>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-offset-2 col-md-4">
            <div class="input-group-btn select" id="select1">
              <button
                type="button"
                class="btn btn-default dropdown-toggle"
                data-toggle="dropdown"
                aria-expanded="false"
              >
                <span class="selected">Quick Start Guide / User Manuals</span
                ><span class="caret"></span>
              </button>
              <ul class="dropdown-menu option" role="menu">
                <li v-for="(key, index) in Object.keys(dropdownItems)" :key="index">
                  <a target="_blank" :href="constructUrl(dropdownItems[key].manual)">{{ key }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="sb-project">
        <div class="col-md-12" v-for="{items, index} in data" :key="index">
          <div class="page-subheader-dashboard">
            <div class="row">
              <div class="col-sm-12 col-md-12">
                <h2>{{ index }}</h2>
              </div>
            </div>
            <table class="product-table">
              <thead>
                <tr>
                  <th>Project Name</th>
                  <th>Status</th>
                  <th>Last Modified</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr @click="goToLink(item.nextUrl)" v-for="item in items" :key="item.id">
                  <td class="product-table-name">
                    {{ item.name }}
                  </td>
                  <td class="product-table-status">
                    {{ item.status }}
                  </td>
                  <td class="product-table-modified">
                    {{ item.lastModified }}
                  </td>
                  <td class="product-table-chevron">
                    <i class="fa fa-chevron-right"></i>
                  </td>
                </tr>
              </tbody>
            </table>
            <hr class="product-divider" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['sbData', 'isSX'],
  data() {
    return {
      activeName: 'first',
      selectedItem: '',
      data: [],
      dropdownItems: {}
    };
  },
  components: {},
  created() {
    this.accessData();
  },
  methods: {
    accessData() {
      const x = this.sbData;
      this.data = x.products;
      this.dropdownItems = x.manuals;
    },
    constructUrl(manual) {
      return `${process.env.VUE_APP_RS_URL}/${manual}`;
    },
    goToLink(link) {
      if (this.isSX) {
        this.$router.push(`/layout/smart-exchange?nextUrl=${link}`);
      } else {
        this.$router.push(`/layout/submission-builder?nextUrl=${link}`);
      }
    }
  }
};
</script>
<style scoped>
.dashboard-icons {
  width: 32px;
  height: 32px;
  margin-right: 17px;
}
.btn-default:hover,
.btn-default:focus,
.btn-default.active.focus,
.btn-default.active:focus,
.btn-default.active:hover,
.btn-default:active.focus,
.btn-default:active:focus,
.btn-default:active:hover,
.open > .dropdown-toggle.btn-default,
.open > .dropdown-toggle.btn-default:hover,
.open > .dropdown-toggle.btn-default:focus {
  background-color: #fff;
  border-color: #0b3c61;
}
.select button {
  width: 100%;
  text-align: left;
}
.select .caret {
  position: absolute;
  right: 10px;
  margin-top: 9px;
}
.select:last-child > .btn {
  border-radius: 20px;
  border-color: #0b3c61;
}
.selected {
  padding-right: 10px;
}
.option {
  width: 100%;
}
.page-subheader-dashboard h2 {
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  color: rgba(0, 0, 0, 0.7);
  margin-top: 10px;
  margin-bottom: 0;
}
.product-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0px 10px;
}
.product-table tbody .product-table-name {
  font-size: 18px;
  line-height: 12px;
}
.product-table th,
.product-table td {
  padding: 4px 24px;
  padding-bottom: 5px;
}
.product-table th,
.product-table td {
  padding: 0px 24px;
}
.product-table tbody tr {
  height: 60px;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 2px 7px;
  border-radius: 10px;
  cursor: pointer;
}
.product-table tbody .product-table-status {
  width: 140px;
}
.product-table tbody .product-table-status,
.product-table tbody .product-table-modified,
.product-table tbody .product-table-chevron {
  font-size: 14px;
  line-height: 16px;
}
.product-table tbody .product-table-modified {
  width: 175px;
}
.product-table tbody .product-table-chevron {
  width: 50px;
  text-align: right;
}
.product-table tbody {
  color: rgb(0, 81, 138);
}
.product-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0px 10px;
}
.header-menu-dashboard-container .page-header-dashboard h1 {
  margin: 0;
}
.header-menu-dashboard-container {
  margin-bottom: 12px;
}
.page-header-dashboard h1 {
  color: #0b3c61;
  font-size: 22px;
  font-weight: 500;
  margin-bottom: 16px;
}
hr {
  margin-bottom: 20px;
  border: 0;
  border-top: 1px solid #eee;
}
.option_check {
  display: none;
  float: right;
  color: #4c9e45;
  margin-top: 10px;
}
.el-select-dropdown__item.selected > .options {
  color: #0b3c61;
}
.el-select-dropdown__item.selected > .option_check {
  display: block;
}
.product-divider {
  margin: 10px 0;
}
.product-table thead th {
  margin-top: 5px;
  border-bottom: 1px dashed #eeeeee;
}
.product-table thead tr {
  height: 45px;
}
.product-table thead {
  color: #0b3c61;
}
.sb-project {
  height: 420px;
  overflow-x: auto;
  overflow-y: auto;
  scrollbar-width: thin;
}
@media only screen and (max-width: 767px) {
  .select {
    padding-top: 10px;
  }
  .sb-project {
    height: 340px;
  }
  .page-subheader-dashboard h2 {
    font-size: 14px;
  }
  .product-table thead th {
    font-size: 12px;
  }
  .product-table tbody .product-table-name,
  .product-table tbody .product-table-status,
  .product-table tbody .product-table-modified {
    font-size: 10px;
  }
}
@media only screen and (max-width: 1024px) {
  .sb-project {
    height: 370px;
  }
  .page-subheader-dashboard h2 {
    font-size: 14px;
  }
  .product-table thead th {
    font-size: 14px;
  }
  .product-table tbody .product-table-name,
  .product-table tbody .product-table-status,
  .product-table tbody .product-table-modified {
    font-size: 12px;
  }
}
</style>
